define('views/modules/conversation/message/send-message-modal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'services/i18n',
    // services
    'services/user',
    'services/toastr-service',
    //models
    'models/conversation/message',
    'collections/conversation/conversations',
    'collections/member/profiles',
    // views
    'views/parts/modal/modal',
    'views/parts/form/chatbox',
    'views/parts/alert/alert-list',
    // templates
    'text!templates/modules/conversation/message/send-message-modal.html',

], function(
    // Libs
    _, Backbone, Mustache, U, i18n,
    // services
    User,
    ToastrService,
    //models
    MMessage,
    CConversations,
    CProfiles,
    // views
    VModal,
    VChatbox,
    VAlertList,
    //templates
    TSendMessageModal

) {
    var VSendMessageModal = VModal.extend({
        template: TSendMessageModal,
        regions: {
            chatbox: '.message-chatbox',
            alert: '.alert-list'
        },

        modal: function() {
            return { title: i18n.t("Write your message") };
        },

        initialize: function(opt) {
            opt = this.options = _.extend({
                attachment: true
            }, opt);

            _.extend(this, {
                group: opt.group,
                profile: opt.profile,
            });

            var model = this.model = new MMessage(),
                users = this.selectedUsers = new CProfiles(),
                collection = this.collection = new CConversations(),
                view = this.view = {
                    chatbox: new VChatbox({
                        button: false,
                        attachment: opt.attachment,
                        attachmentClass: 'attach-btn-modal',
                        attribute: 'content',
                        model: model,
                        context: this,
                        group: opt.group
                    }),
                    alert: new VAlertList()
                };

            this.listenTo(view.chatbox, {
                "file:change": this.onFileChange,
                "file:remove": this.onFileRemove,
            });
        },
        render: function() {
            this.$el.empty().append(Mustache.render(this.template));
            this.generateZones()
                .assign(this.view.chatbox, this.zone.$chatbox)
                .assign(this.view.alert, this.zone.$alert)
                .renderModal();

            this.view.alert.reset();
            return this;
        },
        show: function() {
            this.model.reset();
            this.collection.reset();
            this.view.chatbox.attachments.reset();
            this.render();
        },

        setSelectedUsers: function(collection) {
            this.selectedUsers.reset(collection.models);
            return this;
        },

        sendMessageToSelectedUsers: function() {
            var options = this.options;
            this.selectedUsers.each(function(model) {
                this.collection.add(
                    _.extend(this.getMessageAttributes(), { user: model.id }), { sort: false });
            }, this);

            var success = function() {
                ToastrService.success('your-message-has-been-succesfully-sent');
                return options.callback;
            };

            this.collection.bulkCreate({
                file: this.view.chatbox.getFile(),
                success: success,
                context: options.context
            });

            this.view.chatbox.attachments.reset();
            this.view.chatbox.toggleAttachment(false);
        },

        getMessageAttributes: function() {
            return {
                message: this.view.chatbox.getValue()
            };
        },

        ////////////
        // events //
        ////////////
        onFileChange: function(file) {
            this.model.setAttachment(file);
        },

        onFileRemove: function() {
            this.model.setAttachment();
        },

        onConfirm: function(confirmed) {
            if (confirmed) {
                // Chatbox can't be empty if there is no attachment
                if (this.view.chatbox.isEmpty() && ! this.model.get('attachments')) {
                    this.view.alert.reset().addError('conversation:message_cannot_be_empty');
                    return false;
                }
                this.sendMessageToSelectedUsers();
            }
        },

    });

    return VSendMessageModal;
});

